<app-content>
  <app-breadcrumbs>
    <li>
      Partycypacje społeczne
    </li>
  </app-breadcrumbs>
  <section>
    @if (successMessage) {
      <br>
      <app-alert type="success" (onClose)="successMessage = undefined">{{ successMessage }}</app-alert>
    }
    <h2>
      Partycypacje społeczne
    </h2>
    @if (!loading()) {
      <div class='row'>
        <div class='col-md-6'>
          <div class='form-group'>
            <label for='name'>Szukaj</label>
            <input autocomplete='off' [(ngModel)]='filterValue' id='name' type='text'
                   placeholder='Wpisz nazwę' />
          </div>
        </div>
      </div>
      <div class='row'>
        <div class='col-md-8'>
          <ul class='item-list'>
            <li style='max-width: fit-content'
                *ngFor='let item of surveys() | filterData: filterValue : false : "title"'>
              <div>
                <a
                  [routerLink]='"/konsultacje-spoleczne/" + item.uuid'>
                  {{ item?.title || 'Brak nazwy' }}
                </a>&nbsp;
              </div>
              <div>
                <small>
                  {{ item.description || 'Brak opisu' }}
                </small>
              </div>
            </li>
          </ul>
          @if (!(surveys() | filterData: filterValue : false : "title").length) {
            <app-alert content='Brak wynników' [closable]='false'>
            </app-alert>
          }
        </div>
      </div>
    } @else {
      <app-spinner>
        Poczekaj trwa ładowanie danych...
      </app-spinner>
    }
  </section>
</app-content>
